import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { usePostHog } from 'posthog-js/react';

export const useTrackPageView = () => {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture('$pageview', {
      ['$current_url']: window.location.href
    });
  }, [location, posthog]);
};
